export const splunkRUM = {
  SPLUNK_RUM_AUTH: '0wLtiDnXf51Urp2izn_AJA',
  SPLUNK_REALM: 'us1',
  SPLUNK_APP_NAME: 'Payments',
};
